import Raven from 'raven-js';

export function LocationService($http, $q, $rootScope, $window, consumerService, googleAnalyticsService) {
    'ngInject';
    const data = {};

    const svc = {
        data: data,
        getCurrentLocation: getCurrentLocation,
        queryAutocompleteService: queryAutocompleteService
    };
    return svc;

    function getCurrentLocation() {
        const dfd = $q.defer();

        function _onError(err) {
            dfd.reject(err);
        }

        function _onSuccess(position) {
            function _onReverseGeocodeSuccess(response) {
                if (response.data.status === 'OK') {
                    const result = response.data.results[0];
                    if (result) {
                        consumerService.setLocation(
                            position.coords.latitude,
                            position.coords.longitude,
                            {
                                fromLocalStorage: undefined,
                                fromGoogleAPI: {
                                    addressComponents: result.address_components,
                                    formattedAddress: result.formatted_address
                                }
                            }
                        );

                        dfd.resolve();
                    } else {
                        Raven.captureMessage('No results found from Google Geocoder with lat=' + consumerService.data.latitude + ', lng=' + consumerService.data.longitude, {
                            level: 'info'
                        });
                        dfd.reject();
                    }
                } else {
                    Raven.captureMessage('Google Geocoder failed due to ' + response.data.status + ', error_message: ' + response.data.error_message, {
                        level: 'info'
                    });
                    dfd.reject();
                }
            }

            _reverseGeocode(position.coords.latitude, position.coords.longitude)
                .then(_onReverseGeocodeSuccess);
        }

        if ($window.navigator.geolocation) {
            $window.navigator.geolocation.getCurrentPosition(_onSuccess, _onError, { timeout: 5000 });
        } else {
            _onError('Location Services are not available');
        }
        return dfd.promise;
    }

    function queryAutocompleteService(input) {
        const dfd = $q.defer();

        function _placePredictionsCallBack(predictions, status) {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
                const place = predictions[0];
                data.placesService.getDetails(
                    { placeId: place.place_id },
                    details => {
                        consumerService.setLocation(
                            details.geometry.location.lat(),
                            details.geometry.location.lng(),
                            {
                                fromLocalStorage: undefined,
                                fromGoogleAPI: {
                                    addressComponents: details.address_components,
                                    formattedAddress: details.formatted_address
                                }
                            }
                        );

                        dfd.resolve();
                    }
                );
            }
        }

        if (input === '') {
            dfd.reject();
            return dfd.promise;
        }

        const autocompleteService = new google.maps.places.AutocompleteService();
        autocompleteService.getPlacePredictions(
            {
                input: input,
                types: ['geocode']
            },
            _placePredictionsCallBack
        );

        googleAnalyticsService.trackAddressSearchEvent('click-go-or-hit-enter');

        return dfd.promise;
    }

    function _reverseGeocode(latitude, longitude) {
        return $http({
            method: 'GET',
            url: 'https://maps.googleapis.com/maps/api/geocode/json',
            params: {
                latlng: latitude + ',' + longitude,
                result_type: 'street_address', //eslint-disable-line
                key: $rootScope.googleAPIKey
            }
        });
    }
}
